import { render, staticRenderFns } from "./storeMappingDetail.vue?vue&type=template&id=6203d5c2&scoped=true"
import script from "./storeMappingDetail.vue?vue&type=script&lang=js"
export * from "./storeMappingDetail.vue?vue&type=script&lang=js"
import style0 from "./storeMappingDetail.vue?vue&type=style&index=0&id=6203d5c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203d5c2",
  null
  
)

export default component.exports